
// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ****************************** Import CSS ******************************** //

import "./contact.css";

// ****************************** Import Images ******************************** //

import "/src/assets/contact/dixon-park-map-placeholder.png"
import "/src/assets/contact/front-porch-map-placeholder.png"
import "/src/assets/general-icons/email-icon.svg"

// **************************** Add Top Nav & Footer ************************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup *************** //